import { Capacitor } from '@capacitor/core';
import { SecureStorage } from '@aparajita/capacitor-secure-storage';

const isNative = Capacitor.isNativePlatform();

export async function secureSet(key, value) {
  if (value == null) { await secureRemove(key); return; }
  if (isNative) await SecureStorage.setItem(key, value);
  else localStorage.setItem('ss_' + key, value);
}
export async function secureGet(key) {
  if (isNative) {
    try { return await SecureStorage.getItem(key); } catch { return null; }
  }
  return localStorage.getItem('ss_' + key);
}
export async function secureRemove(key) {
  if (isNative) { try { await SecureStorage.removeItem(key); } catch {} }
  else localStorage.removeItem('ss_' + key);
}
